export default __webpack_public_path__ + "images/hire-icon.ad09174e7c38ab7bf0231bfddd56a0b7.svg";